import { Link } from 'react-router-dom';
import {
  FaInstagram,
  FaFacebookSquare,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
} from 'react-icons/fa';
import { WA_NUMBER } from '../constant/detail';
import { version } from '../../package.json';

const services = [
  { label: 'Pool Maintenance & Cleaning',          to: '/jasa-maintenance-kolam-renang-bali' },
  { label: 'Pool Chemical Supply',                  to: '/jual-chemical-pool-bali' },
  { label: 'Pool Filter Installation & Repair',     to: '/pasang-filter-kolam-renang-bali' },
  { label: 'Pool Water Testing (Test Kit)',          to: '/jasa-testkit-air-kolam-bali' },
  { label: 'Pool Pump Installation & Repair',        to: '/blog/pompa-kolam-renang' },
  { label: 'Regular Pool Service (Weekly/Monthly)',  to: '/jasa-maintenance-kolam-renang-bali' },
  { label: 'Emergency Pool Repair',                  to: '/blog/pool-repairs-bali' },
  { label: 'Pool Water Quality Consultation',        to: '/jasa-testkit-air-kolam-bali' },
  { label: 'Pool Equipment Installation',            to: '/equipment-pool-bali' },
  { label: 'Pool Equipment Supply (Bali)',           to: '/equipment-pool-bali' },
  { label: 'Pool Lighting Installation',             to: '/blog/poollighting-ubud' },
  { label: 'Pool Heat Pump Supply & Installation',   to: '/blog/heat-pump-kolam-renang' },
  { label: 'Pool Ceramic & Tile Supply',             to: '/product' },
  { label: 'Pool Balancing Tank Consultation',       to: '/pool/balancing-tank' },
  { label: 'Pool Design Consultation',               to: '/konsultasi-kolam-renang-bali' },
];

const half = Math.ceil(services.length / 2);
const servicesLeft  = services.slice(0, half);
const servicesRight = services.slice(half);

const FooterSection = () => {
  return (
    <footer id="contact" className="bg-tertiary text-gray-300">

      {/* ── Main grid ── */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* ── Column 1 : Company info ── */}
        <div>
          <h3 className="text-white font-bold text-xl mb-2">
            Pool Shop Suryajaya Teknik
          </h3>
          <p className="text-xs text-gray-400 leading-relaxed mb-6">
            Toko kolam renang profesional di Bali. Melayani perawatan, penjualan chemical, instalasi pompa & filter untuk villa, hotel, dan hunian di seluruh Bali.
          </p>

          {/* Addresses */}
          <div className="space-y-4 mb-6">
            <div className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs font-semibold text-primary uppercase tracking-widest mb-0.5">
                  Toko Ubud
                </p>
                <p className="text-xs text-gray-400 leading-relaxed">
                  Jalan Raya Andong, Petulu,<br />
                  Gianyar, Bali 80571
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs font-semibold text-primary uppercase tracking-widest mb-0.5">
                  Toko Lodtunduh
                </p>
                <p className="text-xs text-gray-400 leading-relaxed">
                  Jl. Raya Kengetan, Lodtunduh,<br />
                  Kec. Ubud, Gianyar, Bali 80571
                </p>
              </div>
            </div>
          </div>

          {/* Business hours */}
          <div className="flex items-start gap-2 text-xs text-gray-400 mb-4">
            <span className="mt-0.5">🕐</span>
            <div>
              <p className="text-xs font-semibold text-primary uppercase tracking-widest mb-0.5">Jam Operasional</p>
              <p>Senin – Sabtu: 08.00 – 17.00 WITA</p>
            </div>
          </div>

          {/* Service areas */}
          <div className="mb-4">
            <p className="text-xs font-semibold text-primary uppercase tracking-widest mb-1">Area Layanan</p>
            <p className="text-xs text-gray-400 leading-relaxed">
              Ubud · Gianyar · Tegallalang · Payangan · Kedewatan · Mas · Lodtunduh · Tampaksiring
            </p>
          </div>

          {/* Email */}
          <a
            href="mailto:suryajayateknik58@gmail.com"
            className="flex items-center gap-2 text-xs text-gray-400 hover:text-primary transition mb-5"
          >
            <FaEnvelope className="flex-shrink-0" />
            <span>suryajayateknik58@gmail.com</span>
          </a>

          {/* Social icons */}
          <div className="flex gap-5">
            <a
              href="https://www.instagram.com/poolshop_suryajayateknik/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram className="text-2xl text-gray-400 hover:text-pink-400 transition" />
            </a>
            <a
              href="https://www.facebook.com/Poolshopsuryajayateknik-101193482275755/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookSquare className="text-2xl text-gray-400 hover:text-blue-400 transition" />
            </a>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=Order:`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp className="text-2xl text-gray-400 hover:text-green-400 transition" />
            </a>
          </div>
        </div>

        {/* ── Columns 2+3 : Our Services (2-column list) ── */}
        <div className="md:col-span-2">
          <h3 className="text-white font-bold text-xl mb-5">Our Services</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5">

            {/* Left service list */}
            <ul className="space-y-2.5">
              {servicesLeft.map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-xs text-gray-400 hover:text-primary transition leading-snug"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Right service list */}
            <ul className="space-y-2.5">
              {servicesRight.map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-xs text-gray-400 hover:text-primary transition leading-snug"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500">
          <a
            href="https://poolshopsuryajayateknik.com/pool/calculator"
            className="hover:text-gray-300 transition"
          >
            2026 &copy; Pool Shop Surya Jaya Teknik
          </a>
          <span className="text-gray-600">v{version}</span>
        </div>
      </div>

    </footer>
  );
};

export default FooterSection;
